import React, { createContext, useContext, useState, ReactNode } from 'react';

interface ThemeContextProps {
  theme: string;
  toggleTheme: () => void;
}

interface ThemeProviderProps {
  children: ReactNode;
}

const ThemeContext = createContext<ThemeContextProps | undefined>(undefined);

const ThemeProvider: React.FC<ThemeProviderProps> = ({ children }) => {
  // HARDCODE: Always force dark mode
  const [theme, setTheme] = useState<string>('dark');

  const toggleTheme = () => {
    // Keep it always dark - no toggle
    setTheme('dark');
    localStorage.setItem('mode', 'dark');
  };

  // Force dark mode on initial load
  React.useEffect(() => {
    localStorage.setItem('mode', 'dark');
    document.body.id = 'dark';
  }, []);

  const contextValue: ThemeContextProps = {
    theme: 'dark', // Always return dark
    toggleTheme,
  };

  return (
    <ThemeContext.Provider value={contextValue}>
      {children}
    </ThemeContext.Provider>
  );
};

const useTheme = (): ThemeContextProps => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
};

export { ThemeProvider, useTheme };
